import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { AppointmentCasesEntityEffects } from './appointment-cases.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([AppointmentCasesEntityEffects])]
})
export class AppointmentCaseEntityModule {}
